/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/require-default-props */
import React from 'react'

import { Form, DatePicker } from 'antd'
import { Rule } from 'antd/lib/form'
import moment from 'moment'

interface DateProps {
  name: string
  label: string
  showTime: boolean
  currentTime?: boolean
  rules?: Rule[]
  initialValue?: moment.Moment
  validRange?: moment.Moment[]
  disabled?: boolean
}

const DateSelector = ({
  name,
  label,
  showTime,
  currentTime,
  rules,
  initialValue,
  validRange,
  disabled,
}: DateProps) => {
  const disabledDate = (current: moment.Moment) => {
    if (validRange) {
      if (validRange[0] && validRange[1]) {
        return current < validRange[0] || current > validRange[1]
      } else {
        return validRange[0] ? current < validRange[0] : current > validRange[1]
      }
    } else {
      return false
    }
  }

  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      initialValue={
        initialValue
          ? currentTime === false //currentTime é um parâmetro opcional, assim ele pode ter o valor undefined
            ? initialValue.set({
                hour: 0,
                minute: 0,
                second: 0,
                millisecond: 0,
              })
            : initialValue
          : undefined
      }
    >
      <DatePicker
        style={{ width: '100%' }}
        showTime={
          showTime
            ? {
                format: 'HH:mm',
              }
            : false
        }
        format={showTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'}
        disabledDate={disabledDate}
        disabled={disabled}
      />
    </Form.Item>
  )
}

export default DateSelector
